import {IService} from "@/model/Service/Service"
import {IAccomodationService} from "@/model/Service/AccomodationService"
import AccomodationServiceFamily, {IAccomodationServiceFamily} from "@/model/ServiceFamily/AccomodationServiceFamily"
import hasAccomodations, {IHasAccomodations} from "@/model/mixins/Accomodation/hasAccomodations"


class HoteliersServiceFamilyBase extends AccomodationServiceFamily  {

    constructor(id: string) {
        super(id)
    }
}

export interface IHoteliersServiceFamily extends IAccomodationServiceFamily {

}

const HoteliersServiceFamily: Constructor<IHoteliersServiceFamily> = HoteliersServiceFamilyBase

export default HoteliersServiceFamily